import api from "./controllersApi";

export const fetchHomeVehicles = (params = {}) =>
  api.get("/api/home/vehicles", { params });


